export const exponentialDelay = (retry = 0, ms = 100) => {
    const delay = Math.pow(2, retry) * ms;
    const randomSum = delay * 0.2 * Math.random(); // 0-20% of the delay
    return delay + randomSum;
};
